/* Shared delegated interaction for cards, galleries and refreshed sections. */
(() => {
  const roots = '.ps-has-notes, .ps-photo-gallery';
  const buttons = '.ps-notes-toggle, .ps-gallery-notes-toggle';
  const media = '.product-card__media, .ps-photo-gallery__pair, .ps-commerce-feature__photo, .ps-editorial-home__photograph';
  const images = '.ps-notes-photo, .ps-photo-gallery__notes, .ps-commerce-feature__notes, .ps-editorial-home__notes';
  const states = new WeakMap();
  const stateFor = root => {
    if (!states.has(root)) states.set(root, { pinned: false, hover: false, focus: false, suppressed: false });
    return states.get(root);
  };
  const visible = state => state.pinned || (!state.suppressed && (state.hover || state.focus));
  function render(root, state) {
    const active = visible(state);
    root.classList.toggle('ps-notes-active', active);
    if (active) root.querySelectorAll(images).forEach(image => { image.loading = 'eager'; });
    root.querySelectorAll(buttons).forEach(button => {
      if (!button.dataset.notesProduct) {
        button.dataset.notesProduct = (button.getAttribute('aria-label') || '').split(' for ')[1] || root.querySelector('.product-title')?.textContent.trim() || '';
      }
      const label = active ? 'Show bottle' : 'Show scent notes';
      (button.querySelector('span') || button).textContent = label;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', label + (button.dataset.notesProduct ? ' for ' + button.dataset.notesProduct : ''));
    });
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    if (event.target.closest?.(buttons)) return;
    const area = event.target.closest?.(media);
    const root = area?.closest(roots);
    if (!root || (event.relatedTarget instanceof Node && area.contains(event.relatedTarget))) return;
    const state = stateFor(root);
    state.hover = true;
    render(root, state);
  });
  document.addEventListener('pointerout', event => {
    const root = event.target.closest?.(roots);
    if (!root || (event.relatedTarget instanceof Node && root.contains(event.relatedTarget))) return;
    const state = stateFor(root);
    state.hover = false;
    state.suppressed = false;
    render(root, state);
  });
  document.addEventListener('focusin', event => {
    const root = event.target.closest?.(roots);
    if (!root || !event.target.closest(media) || event.target.closest(buttons) || event.target.closest('.ps-gallery-zoom')) return;
    const state = stateFor(root);
    state.focus = true;
    render(root, state);
  });
  document.addEventListener('focusout', event => {
    const root = event.target.closest?.(roots);
    if (!root || (event.relatedTarget instanceof Node && root.contains(event.relatedTarget))) return;
    const state = stateFor(root);
    state.focus = false;
    if (!state.hover) state.suppressed = false;
    render(root, state);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest?.(buttons);
    const root = button?.closest(roots);
    if (!root) return;
    const state = stateFor(root);
    const next = !visible(state);
    state.pinned = next;
    // The explicit bottle choice wins over hover until the pointer leaves.
    state.suppressed = !next;
    render(root, state);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest?.(roots);
    if (!root) return;
    const state = stateFor(root);
    state.pinned = false;
    state.suppressed = true;
    render(root, state);
  });
})();
